import { useState } from 'react'

import { ChevronDown, ChevronUp } from 'lucide-react'
import { Control } from 'react-hook-form'

import { Button, SegmentedControl } from '~/components/component-library'

// 'member' is the insufficient scenario viewed as a non-owner.
export type PreviewFormValues = {
  scenario:
    'live' | 'satisfied' | 'single' | 'multi' | 'insufficient' | 'member'
}

// Floating card for stepping through each upgrade scenario with fixture data.
// Shown locally and on the dev deploy only. It minimizes to a pill so the page
// can be shown off; the chosen scenario lives in the parent form and stays
// active while minimized.
export const ScenarioPreviewCard = ({
  control,
}: {
  control: Control<PreviewFormValues>
}) => {
  const [isMinimized, setIsMinimized] = useState(false)

  if (!['development', 'dev'].includes(process.env.APP_ENV ?? '')) return null

  if (isMinimized)
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <Button
          variant="secondary"
          size="small"
          prefix={<ChevronUp />}
          onClick={() => setIsMinimized(false)}
        >
          Preview scenario
        </Button>
      </div>
    )

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 rounded-lg border border-gray-200 bg-white p-3 text-sm shadow-lg dark:border-gray-700 dark:bg-gray-900">
      <div className="flex items-center justify-between gap-4">
        <p className="text-secondary">Preview scenario</p>
        <Button
          variant="tertiary"
          size="small"
          suffix={<ChevronDown />}
          onClick={() => setIsMinimized(true)}
        >
          Minimize
        </Button>
      </div>
      <SegmentedControl
        control={control}
        inputName="scenario"
        ariaLabel="Preview scenario"
        options={[
          { value: 'live', label: 'Live' },
          { value: 'satisfied', label: 'Satisfied' },
          { value: 'single', label: 'Single' },
          { value: 'multi', label: 'Multi' },
          { value: 'insufficient', label: 'Insufficient' },
          { value: 'member', label: 'Member' },
        ]}
      />
    </div>
  )
}
